import { render, staticRenderFns } from "./MenuProfileMovil.vue?vue&type=template&id=90332b0a&"
import script from "./MenuProfileMovil.vue?vue&type=script&lang=js&"
export * from "./MenuProfileMovil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports